// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3rLfe","footer":"ReportModalFilter_footer__1Vah5"};